/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Create Cloud Shell",
  size: 20
}

const SvgCreateCloudShell = ({ size, ...props }: Props) => (
  <Svg
    viewBox="0 0 20 20"
    height={size}
    width={size}
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M4.5.5v13h13V.5h-13z" />
      <path d="M5 17h3v1H5z" />
      <path d="M0 15h1v2h2v1H0zM3 4H0v4h1V5h2zm-3 6h1v3H0zm13 5v3h-3v-1h2v-2z" />
      <path d="M11 3v8-8zm4 4H7h8z" />
    </g>
  </Svg>
)

SvgCreateCloudShell.defaultProps = defaultProps
export default SvgCreateCloudShell
